import dayjs from 'dayjs';
import { z } from 'zod';
import { avatarUrlSchema, nameSchema } from '@/utils/schemas';
import { genderSchema } from './common';

export enum UserType {
  User = 1,
  Admin = 2,
}

export const userInfoSchema = z.object({
  UID: z.number(),
  Type: z.lazy(() => z.nativeEnum(UserType)).catch(UserType.User),
  TelCode: z.string(),
  Phone: z.string(),
  NickName: nameSchema,
  HeadImg: avatarUrlSchema,
  Gender: genderSchema,
  Country: z.string(),
  Sign: nameSchema,
  OnLine: z.number().pipe(z.coerce.boolean()).catch(false),
  LastLoginTime: z
    .string()
    .transform((val) => dayjs(val).toDate())
    .nullish(),
  VChatID: z.string(),
});

export type UserInfoType = z.infer<typeof userInfoSchema>;
